import React from 'react';
import { FaFileInvoice, FaClipboardCheck } from 'react-icons/fa';
import { useApp } from '../../../context/AppContext';
import { DashboardChartGrid, KpiGrid, PortalHero } from '../../../components_shared/PortalDashboard';

export default function PODashboardPage(){
 const { user } = useApp();
 const cards=[
   {icon:<FaFileInvoice/>, label:'Tenders Open', value:3, className:'eduss-dashboard-card-blue'},
   {icon:<FaClipboardCheck/>, label:'Work Orders Issued', value:11, className:'eduss-dashboard-card-green'}
 ];
 return (
   <div className="eduss-dashboard">
     <PortalHero title={`Welcome, ${user?.username || 'PO'}!`} subtitle="Monitor tenders, work orders, and procurement progress." />
     <KpiGrid cards={cards.map(c=>({...c,desc:'Current procurement count'}))} />
     <DashboardChartGrid charts={[
       {title:'Procurement Status',caption:'Open work',type:'bar',data:cards.map(c=>({name:c.label,value:c.value})),color:'#0f6fad'},
       {title:'Order Trend',caption:'Snapshot',type:'line',data:cards.map(c=>({name:c.label,value:c.value})),color:'#10ac84'}
     ]} />
   </div>
 );
}
